// extracted by mini-css-extract-plugin
export var paragraph = "fK_bp";
export var v1 = "fK_jQ";
export var v2 = "fK_jR";
export var v3 = "fK_mt";